import { GoogleButton } from './GoogleButton'

export { GoogleButton }



// WEBPACK FOOTER //
// ./client/Components/GoogleButton/index.js